export const SET_CONTRACTS_DETAIL = "SET_CONTRACTS_DETAIL"
export const SET_CONTRACTS_FIELDS_ITEM = "SET_CONTRACTS_FIELDS_ITEM"
export const SET_BLOB_LINK = "SET_BLOB_LINK"
export const UPDATE_BLOCKED_STATUS = "UPDATE_BLOCKED_STATUS"
export const SET_CITIES_LIST = "SET_CITIES_LIST"
export const SET_CATALOG_LIST = "SET_CATALOG_LIST"
export const SET_COMPANY_FIND_BY_INN = "SET_COMPANY_FIND_BY_INN"